module.exports = __webpack_public_path__ + "static/media/icons-section_40.c2b3c20c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons-section_40.png
// module id = 477
// module chunks = 0